import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_config = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config`,
        method: "GET",
        credentials: "include"
    });
};

export const update_config_general = async (general_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/general`,
        method: "PUT",
        body: JSON.stringify(general_data),
        credentials: "include"
    });
};

export const update_config_policy = async (policy_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/policy`,
        method: "PUT",
        body: JSON.stringify(policy_data),
        credentials: "include"
    });
};

export const update_config_contact = async (contact_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/contact`,
        method: "PUT",
        body: JSON.stringify(contact_data),
        credentials: "include"
    });
};

export const update_config_services = async (services_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/services`,
        method: "PUT",
        body: JSON.stringify(services_data),
        credentials: "include"
    });
};

export const fetch_config_services = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/services`,
        method: "GET",
        credentials: "include"
    });
};

export const fetch_config_links = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/links`,
        method: "GET",
        credentials: "include"
    });
};

export const fetch_link_by_id = async (link_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/links/id/${link_id}`,
        method: "GET",
        credentials: "include"
    });
};

export const update_config_links = async (links_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/links`,
        method: "PUT",
        body: JSON.stringify(links_data),
        credentials: "include"
    });
};

export const fetch_announcement_banner = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/config/announcement`,
        method: "GET",
        credentials: "include"
    });
};
